import { parseIntervalFromRrule, parseWeekDaysFromRrule } from './parse-rrule';

// "Every day" is the bare FREQ=DAILY rule (or a weekly rule covering all 7 week
// days) at interval 1 — see parse-rrule.ts. An interval > 1 (every other day) or
// a subset of week days is not every-day.
export const isEveryDayRrule = (rrule: string) =>
  parseIntervalFromRrule(rrule) === 1 &&
  parseWeekDaysFromRrule(rrule).length === 7;
